import { hasDescription, Memo, MemoType } from 'models/Memo';
import { UseFormReturn } from 'react-hook-form';
import { FormValues } from './useFormInitialisation';
import { useToggleableField } from './useToggleableField';

interface Props {
  memo?: Memo;
  methods: UseFormReturn<FormValues>;
  selectedMemoType: MemoType;
}

export const useDescription = ({ memo, methods, selectedMemoType }: Props) => {
  const canShowDescription = [
    MemoType.Calendar,
    MemoType.Link,
    MemoType.TaskList,
  ].includes(selectedMemoType);

  const hasInitialValue = !!(memo && hasDescription(memo) && memo.description);

  const { isVisible, toggle } = useToggleableField({
    fieldName: 'description',
    methods,
    canShow: canShowDescription,
    hasInitialValue,
  });

  return {
    canShowDescription,
    isDescriptionVisible: isVisible,
    toggleDescription: toggle,
  };
};
